import { mapGetters } from "vuex";
import { storeGetters } from "../store/storeGetters.constant";

export default {
    computed: {
        ...mapGetters({
            communityInfo: `chapter/${storeGetters.communityInfo}`,
        }),
        canViewAboutTile() {
            return this.canViewAbout || this.canViewChair || this.canViewSponsors;
        },
        canViewAbout() {
            return this.communityInfo
                && this.communityInfo.communityId === this.$route.params.communityId
                && this.communityInfo.userAccess
                && this.communityInfo.userAccess.canViewAbout;
        },
        canViewChair() {
            return this.communityInfo
                && this.communityInfo.communityId === this.$route.params.communityId
                && this.communityInfo.userAccess
                && this.communityInfo.userAccess.canViewChairMessage;
        },
        canViewSponsors() {
            return this.communityInfo
                && this.communityInfo.communityId === this.$route.params.communityId
                && this.communityInfo.userAccess
                && this.communityInfo.userAccess.canViewSponsors;
        },
        canViewWaiversLink() {
            return this.communityInfo
                && this.communityInfo.communityId === this.$route.params.communityId
                && this.communityInfo.userAccess &&
                this.communityInfo.userAccess.canViewWaiversLink;
        },
    },
};
